import { Stack, CardActions, Typography, useMediaQuery } from '@mui/material';
import useMain from 'hooks/useMain';
import { useMemo, useRef, useState } from 'react';
import CusDetailButtonGroup from './CusDetailButtonGroup';
import CusDetailCard from './CusDetailCard';
import CusDetailSummary from './CusDetailSummary';
import CusDrawer from './CusDrawer';
import MainCard from './MainCard';
import { useTheme } from '@mui/material/styles';
import { SidebarForm } from 'pages/module/component';
import CusAuditCard from './CusAuditCard';
import { micService } from 'services/mic';
import { detailsWorkflowFields } from 'pages/module/field';
import { handleAsyncCall, toDefaultMicDateFormat } from 'utils/common';
import moment from 'moment';
import { useData } from 'pages/module/hook/useData';
import { useSelector } from 'react-redux';

const CustDetail = ({
  details,
  summaryFieldsLabel,
  summaryShowField,
  summaryDetailId,
  summaryFetchDetail,
  // setOpenSidebar,
  targetTypeStepsWithComplete = []
  // handleEdit
}) => {
  const [auditTrails, setAuditTrails] = useState([]);
  const project = useSelector((state) => state.auth.project);
  const [openSiderbar, setOpenSidebar] = useState(false);
  const { t, upperCaseLang } = useMain();
  const [showAuditTrails, setShowAuditTrails] = useState(false);
  const sidebarFormRef = useRef(null);
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const [currentStepCode, setCurrentStepCode] = useState(null);
  const fields =
    details &&
    _.map(summaryShowField, (value) => {
      const key = _.find(Object.keys(details), (o) => _.isEqual(o, value));
      const labelObject = _.find(summaryFieldsLabel, ({ id }) => _.isEqual(id, key));
      return { label: labelObject?.label, id: labelObject?.id };
    });

  const sideBarData = useMemo(
    () => targetTypeStepsWithComplete.find((d) => d?.Step === currentStepCode) ?? {},
    [currentStepCode, targetTypeStepsWithComplete]
  );

  const {
    categoryOptions,
    subCategoryOptions,
    blockOptions,
    concreteOptions,
    floorOptions,
    unitOptions,
    selectedRegion,
    selectedRoom,
    setSelectedRoom,
    selectedFloor,
    targetTypeSteps,
    supplierOptions,
    currentBctype,
    setSelectedFloor,
    setSelectedRegion,
    isLoading,
    setLoading,
    rsCompanyOptions
  } = useData({});

  const handleViewAuditTrail = (stepCode) => {
    setCurrentStepCode(stepCode);
    handleAsyncCall({
      service: micService.getHistory,
      params: {
        stepCode,
        id: summaryDetailId
      },
      successCb: (res) => {
        try {
          const sanitisedAuditTrails = res.data.map((at) => {
            const _detailEntries = Object.entries(at).map(([key, value]) => {
              if (key.includes('UpdatedDate')) {
                return [key, moment(value).format('YYYY-MM-DDTHH:mm:ss')];
              }
              if (key.includes('Date')) {
                return [key, toDefaultMicDateFormat(value)];
              }
              return [key, value];
            });
            return Object.fromEntries(_detailEntries);
          });
          setAuditTrails(sanitisedAuditTrails);
          setShowAuditTrails(true);
          setOpenSidebar(true);
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  const onSubmit = async (data) => {
    const dataEntries = Object.entries({
      ...data,
      Remark: data[`Remark${sideBarData?.Portion}`],
      IsCompleted: data[`IsCompleted${sideBarData?.Portion}`]
    });
    const modifiedDataEntries = dataEntries.map(([key, value]) => {
      if (_.isBoolean(value)) {
        return [key, value ? 1 : 0];
      }
      return [key, value];
    });

    const newData = Object.fromEntries(modifiedDataEntries);
    const params = {
      StepCode: sideBarData?.Step,
      Data: { Id: summaryDetailId, ...newData }
    };
    handleAsyncCall({
      service: micService.modifyRfidStepDetails,
      params,
      showSuccessAlert: true,
      successCb: (res) => {
        setAuditTrails([]);
        summaryFetchDetail();
        setOpenSidebar(false);
        // setShowAuditTrails(false);
      }
    });
  };

  const Header = () => {
    return (
      <Stack direction="row" spacing={2} alignItems="flex-end" justifyContent={matchesSM && 'space-between'}>
        <Typography variant="h5" sx={{ color: theme.palette.primary[400] }}>
          {t('WORKING_PROCESS')}
        </Typography>
        <Typography variant="body2">{t('WORKING_PROCESS_TOTAL', { WORKINGPROCESSTOTAL: targetTypeStepsWithComplete.length })}</Typography>
      </Stack>
    );
  };

  return (
    <>
      {/* <CardActions
        sx={{
          position: 'sticky',
          top: '60px',
          bgcolor: 'white',
          zIndex: 999,
          //   mb: 2,
          padding: 0
        }}
      >
        <CusDetailButtonGroup
          data={data}
          detailId={summaryDetailId}
          fetchDetail={summaryFetchDetail}
          sideBarData={sideBarData}
        />
      </CardActions> */}
      <CusDetailSummary
        details={details}
        currentBctype={currentBctype}
        fields={fields}
        showField={summaryShowField}
        detailId={summaryDetailId}
        fetchDetail={summaryFetchDetail}
      />

      <MainCard title={Header()} headerSX={{ marginLeft: '16px', marginBottom: '-16px', marginRight: '16px' }}>
        {details &&
          targetTypeStepsWithComplete.map((data, i) => {
            return (
              <CusDetailCard
                setOpenSidebar={setOpenSidebar}
                handleViewAuditTrail={handleViewAuditTrail}
                data={data}
                key={data?.Step}
                isCompleted={data?.IsCompleted}
                details={details} // handleEdit={handleEdit}
                setCurrentStepCode={setCurrentStepCode}
              />
            );
          })}
      </MainCard>
      <CusDrawer
        open={openSiderbar}
        onClose={() => {
          setOpenSidebar(false);
          setShowAuditTrails(false);
          // setAuditTrails([]);
        }}
      >
        {!_.isEmpty(sideBarData) && !showAuditTrails && (
          <SidebarForm
            formData={details}
            title={`${sideBarData[`StepDesc${upperCaseLang}`]}`}
            workflowTitle={t('DETAIL_EDIT')}
            ref={sidebarFormRef}
            buttonLabel={t('BTN_CONFIRM_SAVE')}
            handleSubmit={onSubmit}
            fields={detailsWorkflowFields({
              t,
              type: sideBarData?.Bctype,
              stepCode: sideBarData?.Step,
              portion: sideBarData?.Portion,
              categoryOptions,
              rsCompanyOptions,
              subCategoryOptions,
              concreteOptions,
              blockOptions,
              floorOptions,
              unitOptions,
              supplierOptions,
              selectedRoom,
              setSelectedRegion,
              setSelectedFloor,
              setSelectedRoom,
              selectedRegion,
              selectedFloor,
              upperCaseLang,
              preview: sideBarData?.CanUpdate,
              disposed: details?.Dispose,
              setValue: sidebarFormRef.current?.setValue,
              project: project
            }).filter(({ id }) => {
              return sideBarData?.AllowField.findIndex((af) => id?.includes(af)) >= 0;
            })}
            // allDisabled={getValues()?.Dispose || preview}
            submitButtonProps={{
              // sx: { borderRadius: '12px', width: 'auto' },
              disabled: details?.Dispose
            }}
          />
        )}
        {showAuditTrails && (
          <CusAuditCard
            title={t('SHOW_AUDIT')}
            subTitle={t('SHOW_RECORD')}
            subRightTtile={t('TOTAL_RECORDS', { TOTALRECORDS: auditTrails.length })}
            auditData={auditTrails}
            fields={detailsWorkflowFields({
              isAudit: true,
              t,
              type: sideBarData?.Bctype,
              stepCode: sideBarData?.Step,
              categoryOptions,
              subCategoryOptions,
              blockOptions,
              floorOptions,
              unitOptions,
              upperCaseLang,
              project: project
            })}
          />
        )}
      </CusDrawer>
    </>
  );
};

export default CustDetail;
